import { createAppIdentity } from '@rcw/utils';

/**
 * X-App-Name / X-App-Version, sent on every call to a Roland back-end service so the
 * services can attribute traffic to an app and a release.
 *
 * REACT_APP_NAME carries the name. It existed in the env files since the pre-monorepo
 * repos but nothing ever read it, so this is its first consumer; the fallback below
 * is only a guard against an environment that forgets to set it. The version comes from
 * apps/home/package.json, injected at build time.
 *
 * serviceUrls is what this app owns: the gateway, which fronts entitlements, accounts,
 * key and payment, and BMS. Everything else it calls — rcpapi, Zendesk, GeoIP — belongs
 * to another team and is left untouched.
 */
export const {
  appHeaders, isServiceUrl, withAppHeaders, applyAppHeaders,
} = createAppIdentity({
  name: import.meta.env.REACT_APP_NAME,
  fallbackName: 'home',
  version: import.meta.env.REACT_APP_RELEASE_VERSION,
  serviceUrls: [import.meta.env.REACT_APP_CUSTOMERS, import.meta.env.REACT_APP_BMS_SERVICE],
});
